import { keepTrackApi } from '@app/keepTrackApi';
import { ecf2eci, rae2ecf } from '@ootk/src/main';
import { Line, LineColors } from './line';
export class SensorScanHorizonLine extends Line {
    sensor;
    az_ = -90;
    minAz_;
    maxAz_;
    constructor(sensor, face = 1, faces = 2, color = LineColors.CYAN) {
        super();
        this.sensor = sensor;
        this.az_ = sensor.minAz;
        const maxAz = sensor.maxAz > sensor.minAz ? sensor.maxAz : sensor.maxAz - 360;
        const minAz = sensor.minAz;
        const azRange = maxAz - minAz;
        this.minAz_ = minAz + (azRange / faces) * (face - 1);
        this.maxAz_ = minAz + (azRange / faces) * (face);
        this.validateColor(color);
        this.color_ = color;
    }
    update() {
        const eci = this.sensor.eci(keepTrackApi.getTimeManager().simulationTimeObj);
        const eciArr = [eci.x, eci.y, eci.z];
        this.updateAzimuth_();
        const eciArr2 = this.calculateEciPosition_();
        this.updateVertBuf([eciArr, eciArr2]);
    }
    updateAzimuth_() {
        this.az_ = (this.az_ + settingsManager.lineScanSpeedRadar);
        // Normalize azimuth
        if (this.az_ > 360) {
            this.az_ = 0;
        }
        // Is azimuth outside of FOV?
        if ((this.maxAz_ > this.minAz_ && this.az_ > this.maxAz_) ||
            (this.maxAz_ < this.minAz_ &&
                this.az_ > this.maxAz_ &&
                this.az_ < this.minAz_)) {
            // Reset it
            this.az_ = this.minAz_;
        }
    }
    calculateEciPosition_() {
        const lla = this.sensor.lla();
        const eci = ecf2eci(rae2ecf({
            rng: this.sensor.maxRng,
            az: this.az_,
            el: this.sensor.minEl,
        }, {
            lat: lla.lat,
            lon: lla.lon,
            alt: lla.alt + 30,
        }), keepTrackApi.getTimeManager().gmst);
        return [eci.x, eci.y, eci.z];
    }
}
